import { defineMessages } from 'react-intl-next';
export var avatarGroupMessages = defineMessages({
  editors: {
    id: 'fabric.editor.editors',
    defaultMessage: 'Editors',
    description: 'classifying the people that are currently editing the document'
  }
});